// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import PrismicDOM from 'prismic-dom'
import VueLazyload from 'vue-lazyload'
import VueProgressBar from 'vue-progressbar'

import checkView from 'vue-check-view'
Vue.use(checkView)

Vue.config.autoOpenBrowser = false
Vue.config.productionTip = false
Vue.config.PRISMIC = process.env.PRISMIC
Vue.config.IMGS = process.env.CLOUDINARY
Vue.config.bkpt = {
  mobile: 600,
  prjGrid_2col: 600
}

Vue.$html = (key) => {
  return PrismicDOM.RichText.asHtml(key, () => {
    return '/'
  })
}

Vue.use(VueLazyload)
Vue.use(VueProgressBar, {
  color: 'lightgray',
  thickness: '2px'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js